import { render, staticRenderFns } from "./DetailsPaymentsTable.vue?vue&type=template&id=0d4ccf1c&scoped=true"
import script from "./DetailsPaymentsTable.vue?vue&type=script&lang=js"
export * from "./DetailsPaymentsTable.vue?vue&type=script&lang=js"
import style0 from "./DetailsPaymentsTable.vue?vue&type=style&index=0&id=0d4ccf1c&prod&scoped=true&lang=scss"
import style1 from "./DetailsPaymentsTable.vue?vue&type=style&index=1&id=0d4ccf1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4ccf1c",
  null
  
)

export default component.exports